export default __webpack_public_path__ + "static/media/medication.a97fb18e.svg";